import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { shortDate, OnFire } from "./EventCard";
import { posStyle } from "./CardImagePositioner";

const TYPE_CLASS = { allnighter: "gg-type-allnighter", alldayer: "gg-type-alldayer", live_show: "gg-type-live_show", record_fair: "gg-type-record_fair" };
const pins = {};
const pinFor = type => pins[type] || (pins[type] = L.divIcon({
  className: "gg-pin",
  html: `<span class="gg-pin-dot ${TYPE_CLASS[type] || ""}"></span>`,
  iconSize: [18, 18], iconAnchor: [9, 9], popupAnchor: [0, -10],
}));

export default function EventMapView({ events }) {
  const { t, lang } = useApp();
  const points = events.filter(e => e.lat && e.lng);
  const center = points[0] ? [points[0].lat, points[0].lng] : [51.5, 5];
  return (
    <div className="border border-foreground" data-testid="map-view" style={{ height: "min(70vh, 640px)" }}>
      <MapContainer center={center} zoom={4} scrollWheelZoom={true} style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution='&copy; <a href="https://openstreetmap.org">OSM</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {points.map(e => (
          <Marker key={e.event_id} position={[e.lat, e.lng]} icon={pinFor(e.event_type)}>
            <Popup maxWidth={260} minWidth={220}>
              <div data-testid={`map-popup-${e.slug}`}>
                <div className="aspect-[16/9] overflow-hidden bg-muted border border-foreground"><img src={e.main_image} alt="" className="gg-flyer" style={posStyle(e.image_position)} /></div>
                <div className="mt-2 font-display text-primary font-semibold text-xs">{shortDate(e.start_date, lang)}</div>
                <div className="font-display uppercase text-base leading-tight">{e.name}</div>
                <div className="text-xs mt-0.5">{e.city} · {t(`types.${e.event_type}`)}{e.going_count > 0 && <span className="text-muted-foreground"> · {t("goingCount", { n: e.going_count })} <OnFire event={e} className="w-3 h-3 inline-block align-[-2px]" /></span>}</div>
                <Link to={`/events/${e.slug}`} className={`gg-btn-primary !py-2 !px-3 !text-xs mt-2 w-full ${TYPE_CLASS[e.event_type] ? `${TYPE_CLASS[e.event_type]} !border-transparent` : ""}`} data-testid={`map-popup-link-${e.slug}`}>
                  {t("viewEvent")} →
                </Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
